import React from "react";
import DualListBox from "react-dual-listbox";

// region Imports - External libraries
import { Grid } from "@material-ui/core";
// endregion Imports - External libraries
// region Imports - Languages
import { DualListboxMessages } from "@shared/languages/interfaces";
// endregion Imports - Languages

interface UserVehicleRestrictionsProps {
  t: (key: string) => string;
  modalType: "details" | "update" | "register";
  activeRestrictVehicleIds: string[];
  setActiveRestrictVehicleIds: (ids: string[]) => void;
  optionsRestrictVehicles: any[]; // Vehicle[]
  setActiveRestrictVehicles: (vehicles: any[]) => void;
  formattedRestrictVehicleOptions: any[];
  dualListboxLang: any;
}
const UserVehicleRestrictions: React.FC<UserVehicleRestrictionsProps> = ({
  t,
  modalType,
  activeRestrictVehicleIds,
  setActiveRestrictVehicleIds,
  optionsRestrictVehicles,
  setActiveRestrictVehicles,
  formattedRestrictVehicleOptions,
  dualListboxLang
}) => {
  return (
    <Grid item xs={12} md={12} lg={12}>
      <DualListBox
        options={formattedRestrictVehicleOptions}
        selected={activeRestrictVehicleIds}
        onChange={(newValue) => {
          setActiveRestrictVehicleIds(newValue);
          setActiveRestrictVehicles(newValue.map(
            (id) => optionsRestrictVehicles.find(
              (vehicle) => vehicle.id_vehicle === id
            )
          ));
        }}
        disabled={modalType === "details"}
        canFilter
        filterPlaceholder={t(DualListboxMessages.filterPlaceholder)}
        lang={dualListboxLang}
        showHeaderLabels
      />
    </Grid>
  );
};

export default UserVehicleRestrictions;
